// src/store/action-creators/otherDataActionCreator.ts
export const setOtherData = (data: any) => {
  return (dispatch: any) => {
    dispatch({
      type: "setData",
      payload: data,
    });
  };
};

export const getOtherData = (data: any) => {
  return (dispatch: any) => {
    dispatch({
      type: "getData",
      payload: data,
    });
  };
};
